export default {
  noSignalsSelected: 'Keine Signale ausgewählt. Verwenden Sie Voreinstellungen oder Expertenansicht, um Signale auszuwählen.',
};
